import React, { useCallback } from 'react';
import CallRecordItemV2 from 'flow/components/call-history-v2/CallRecordItemV2';
import { DateGroupedRowProps } from 'flow/components/call-history-v2/DateGroupedList';
import { PageType } from 'flow/components/call-history-v2/types';
import ListRowFrame from 'flow/components/nav/list-keys/ListRowFrame';
import { CallRecordKey, QueueKey } from 'flow/types/EntityKeys';

// The row gets its call as a key, not as a row object. The list makes new row
// objects each time its data changes, so a row object would render every row
// each time.
interface Props extends DateGroupedRowProps {
    callRecordKey: CallRecordKey;
    queueKey?: QueueKey;
    pageType: PageType;
    /** Opens the call. Keep one function for the life of the list. */
    onOpen: (callRecordKey: CallRecordKey) => void;
}

const RelatedCallRecordItem = ({
    callRecordKey,
    queueKey,
    pageType,
    onOpen,
    index,
    tabStopStore,
    tabStopKey,
    onUnmountWithFocus,
}: Props) => {
    // One function for the life of the row, so the card keeps its render
    // when the row gets a new index, as when a call comes in above it.
    const open = useCallback(
        () => onOpen(callRecordKey),
        [onOpen, callRecordKey],
    );

    return (
        <ListRowFrame
            index={index}
            isFocusable={true}
            tabStopStore={tabStopStore}
            tabStopKey={tabStopKey}
            onUnmountWithFocus={onUnmountWithFocus}
        >
            {/* The button is the contact name inside the card, stretched over
                the whole card, so the ticket and call buttons, the menu and
                the player sit beside it rather than inside a button. */}
            <CallRecordItemV2
                callRecordKey={callRecordKey}
                queueKey={queueKey}
                segmentContext="PBX call detail"
                pageType={pageType}
                onOpen={open}
            />
        </ListRowFrame>
    );
};

export default React.memo(RelatedCallRecordItem);
